import React, { useState } from 'react';
import { useApp } from '../../contexts/AppContext';
import './Forms.css';

interface SectionFormProps {
  bookId: string;
  bookTitle: string;
  onCancel: () => void;
}

export const SectionForm: React.FC<SectionFormProps> = ({ bookId, bookTitle, onCancel }) => {
  const { createSection } = useApp();
  const [formData, setFormData] = useState({
    title: '',
    subtitle: '',
    section_number: '',
    show_in_toc: true,
  });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await createSection(bookId, formData);
      onCancel(); // Close the form on success
    } catch (error) {
      // Error is handled in context
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  return (
    <div className="form-view">
      <div className="content-header">
        <h2>Add New Section</h2>
        <p>Add a section to: {bookTitle}</p>
      </div>
      <div className="content-body">
        <div className="form-container">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Title *</label>
              <input
                type="text"
                name="title"
                value={formData.title}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label>Subtitle</label>
              <input
                type="text"
                name="subtitle"
                value={formData.subtitle}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>Section Number</label>
              <input
                type="text"
                name="section_number"
                value={formData.section_number}
                onChange={handleChange}
                placeholder="e.g., 1.1"
              />
            </div>
            <div className="form-group">
              <label>
                <input
                  type="checkbox"
                  name="show_in_toc"
                  checked={formData.show_in_toc}
                  onChange={handleChange}
                />
                {' '}Show in Table of Contents
              </label>
            </div>
            <div className="form-actions">
              <button type="submit" className="btn btn-primary">
                Create Section
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={onCancel}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};